// // src/pages/AddNewPermissionPage.jsx
// import React, { useState, useEffect, useMemo } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { apiCall } from "../Apis/apiCall";
// import Breadcrumb from "../components/Breadcrumb";
// import CustomSelect from "../components/common/CustomSelect";
// import LoadingComponent from "../components/ui/LoadingComponent";
// import { CancelButtonForm, UpdateButtonForm } from "../components/ui/Button";
// import { handleApiResponse, handleCustomResponse } from "../utils/response";

// const AddNewPermissionPage = () => {
//   const [selectedPermissions, setSelectedPermissions] = useState({});
//   const [selectedRoleId, setSelectedRoleId] = useState("");
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [clientRoles, setClientRoles] = useState([]);
//   const [isLoadingRoles, setIsLoadingRoles] = useState(false);
//   const [allPermissions, setAllPermissions] = useState([]);
//   const [isLoadingPermissions, setIsLoadingPermissions] = useState(false);
//   const [rolePermissions, setRolePermissions] = useState([]);
//   const [isLoadingRolePermissions, setIsLoadingRolePermissions] =
//     useState(false);
//   const navigate = useNavigate();
//   const [modules, setModules] = useState([]);

//   // Fetch client roles
//   useEffect(() => {
//     const fetchClientRoles = async () => {
//       setIsLoadingRoles(true);
//       try {
//         const response = await apiCall(
//           "get",
//           "/get-all-client-roles?want_pagination=0&sort_by=role_name&sort_order=asc"
//         );
//         if (!response?.data?.data) {
//           throw new Error("Invalid response format from server.");
//         }
//         const roles = Array.isArray(response.data.data)
//           ? response.data.data
//           : [];
//         const uniqueRoles = roles.map((role) => ({
//           id: role.client_role_id,
//           name: role.role_name || `Role ${role.client_role_id}`,
//         }));
//         setClientRoles(uniqueRoles);
//       } catch (error) {
//         setClientRoles([]);
//       } finally {
//         setIsLoadingRoles(false);
//       }
//     };
//     fetchClientRoles();
//   }, []);

//   // Fetch all permissions and role permissions on role selection
//   useEffect(() => {
//     if (!selectedRoleId) {
//       setAllPermissions([]);
//       setRolePermissions([]);
//       setSelectedPermissions({});
//       setModules([]);
//       return;
//     }
//     const fetchData = async () => {
//       setIsLoadingPermissions(true);
//       setIsLoadingRolePermissions(true);
//       try {
//         const permResponse = await apiCall(
//           "get",
//           "/get-all-client-permissions?want_pagination=0&sort_by=module_name&sort_order=asc"
//         );
//         if (!permResponse?.data?.data) {
//           throw new Error("Invalid response format from server.");
//         }
//         const permissions = Array.isArray(permResponse.data.data)
//           ? permResponse.data.data
//           : [];
//         setAllPermissions(permissions);
//         const moduleMap = {};
//         permissions.forEach((perm) => {
//           const moduleName = perm.module_name || "General";
//           if (!moduleMap[moduleName]) {
//             moduleMap[moduleName] = { name: moduleName, permissions: [] };
//           }
//           moduleMap[moduleName].permissions.push({
//             permission_key: perm.permission_key,
//             client_permission_id: perm.client_permission_id,
//           });
//         });
//         setModules(Object.values(moduleMap));
//         const rolePermResponse = await apiCall(
//           "get",
//           `/get-client-role-permissions-by-id?client_role_id=${selectedRoleId}`
//         );
//         if (!rolePermResponse?.data?.data) {
//           throw new Error("Invalid response format from server.");
//         }
//         const rolePerms = Array.isArray(rolePermResponse.data.data)
//           ? rolePermResponse.data.data
//           : [];
//         setRolePermissions(rolePerms);
//       } catch (error) {
//         setAllPermissions([]);
//         setRolePermissions([]);
//         setModules([]);
//       } finally {
//         setIsLoadingPermissions(false);
//         setIsLoadingRolePermissions(false);
//       }
//     };
//     fetchData();
//   }, [selectedRoleId]);

//   // Update selected permissions based on role permissions
//   useEffect(() => {
//     if (!rolePermissions.length && !allPermissions.length) {
//       setSelectedPermissions({});
//       return;
//     }
//     const newSelectedPermissions = {};
//     modules.forEach((module) => {
//       newSelectedPermissions[module.name] = {};
//       module.permissions.forEach((perm) => {
//         const rolePerm = rolePermissions.find(
//           (rp) =>
//             rp.client_permission_id === perm.client_permission_id &&
//             rp.is_allowed &&
//             allPermissions.some(
//               (p) => p.client_permission_id === rp.client_permission_id
//             )
//         );
//         newSelectedPermissions[module.name][perm.permission_key] = !!rolePerm;
//       });
//       newSelectedPermissions[module.name].__main = module.permissions.every(
//         (perm) => newSelectedPermissions[module.name][perm.permission_key]
//       );
//     });
//     setSelectedPermissions(newSelectedPermissions);
//   }, [rolePermissions, modules, allPermissions]);

//   // Handle checkbox change
//   const handleCheckboxChange = (moduleName, permissionKey) => {
//     setSelectedPermissions((prev) => {
//       const newSelected = { ...prev };
//       newSelected[moduleName] = newSelected[moduleName] || {};
//       newSelected[moduleName][permissionKey] =
//         !newSelected[moduleName][permissionKey];
//       const module = modules.find((m) => m.name === moduleName);
//       if (module) {
//         newSelected[moduleName].__main = module.permissions.every(
//           (perm) => newSelected[moduleName][perm.permission_key]
//         );
//       }
//       return newSelected;
//     });
//   };

//   // Select/deselect all permissions for a module
//   const handleSelectAllPermissions = (moduleName) => {
//     setSelectedPermissions((prev) => {
//       const newSelected = { ...prev };
//       newSelected[moduleName] = newSelected[moduleName] || {};
//       const module = modules.find((m) => m.name === moduleName);
//       const allSelected = module.permissions.every(
//         (perm) => newSelected[moduleName][perm.permission_key]
//       );
//       module.permissions.forEach((perm) => {
//         newSelected[moduleName][perm.permission_key] = !allSelected;
//       });
//       newSelected[moduleName].__main = !allSelected;
//       return newSelected;
//     });
//   };

//   // Select all modules
//   const handleSelectAllModules = () => {
//     setSelectedPermissions((prev) => {
//       const newSelected = { ...prev };
//       modules.forEach((module) => {
//         newSelected[module.name] = newSelected[module.name] || {};
//         module.permissions.forEach((perm) => {
//           newSelected[module.name][perm.permission_key] = true;
//         });
//         newSelected[module.name].__main = true;
//       });
//       return newSelected;
//     });
//   };

//   // Deselect all modules
//   const handleDeselectAllModules = () => {
//     setSelectedPermissions((prev) => {
//       const newSelected = { ...prev };
//       modules.forEach((module) => {
//         newSelected[module.name] = newSelected[module.name] || {};
//         module.permissions.forEach((perm) => {
//           newSelected[module.name][perm.permission_key] = false;
//         });
//         newSelected[module.name].__main = false;
//       });
//       return newSelected;
//     });
//   };

//   // Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!selectedRoleId) {
//       handleCustomResponse("error", "Please select a valid role.");
//       return;
//     }
//     setIsSubmitting(true);
//     const selectedPermissionIds = [];
//     Object.keys(selectedPermissions).forEach((moduleName) => {
//       const module = modules.find((m) => m.name === moduleName);
//       if (module) {
//         Object.keys(selectedPermissions[moduleName]).forEach(
//           (permissionKey) => {
//             if (
//               permissionKey !== "__main" &&
//               selectedPermissions[moduleName][permissionKey]
//             ) {
//               const permission = module.permissions.find(
//                 (perm) => perm.permission_key === permissionKey
//               );
//               if (permission && permission.client_permission_id) {
//                 selectedPermissionIds.push(permission.client_permission_id);
//               }
//             }
//           }
//         );
//       }
//     });
//     const uniquePermissionIds = [...new Set(selectedPermissionIds)];
//     try {
//       const assignPayload = {
//         client_role_id: parseInt(selectedRoleId),
//         client_permission_ids: uniquePermissionIds,
//       };
//       const response = await apiCall(
//         "post",
//         "/assign-role-permissions",
//         assignPayload
//       );
//       handleApiResponse(
//         response.data,
//         "Permissions assigned successfully!",
//         "POST"
//       );

//       setSelectedRoleId("");
//       setSelectedPermissions({});
//       navigate(-1);
//     } catch (error) {
//       const err = error.response?.data || error.message;
//       handleApiResponse(err, "Failed to update permissions.", "POST");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   // Optimize filtered modules with useMemo
//   const filteredModules = useMemo(
//     () => (allPermissions.length > 0 ? modules : []),
//     [allPermissions, modules]
//   );

//   // if (isLoadingPermissions || isLoadingRoles) {
//   //   return (
//   //     <>
//   //       <Breadcrumb title={"Assign Permission"} />
//   //       <LoadingComponent />
//   //     </>
//   //   );
//   // }
//   return (
//     <>
//       <Breadcrumb title={"Assign Permission"} />
//       <div className="card h-100 p-0 radius-12">
//         <div className="card-body p-40">
//           <form onSubmit={handleSubmit}>
//             <div className="row gy-4">
//               <div className="col-12">
//                 <div className="mb-6">
//                   <label className="form-label fw-semibold text-primary-light text-sm mb-2">
//                     Select Role <span className="text-danger">*</span>
//                   </label>

//                   <CustomSelect
//                     name="role"
//                     value={selectedRoleId}
//                     onChange={(selected) =>
//                       setSelectedRoleId(selected ? selected.value : "")
//                     }
//                     options={clientRoles.map((role) => ({
//                       label: role.name
//                         .split("_")
//                         .map(
//                           (word) => word.charAt(0).toUpperCase() + word.slice(1)
//                         )
//                         .join(" "),
//                       value: role.id,
//                     }))}
//                     placeholder="Select a role"
//                     addNewLabel="Add New Role"
//                     addNewRoute="/staff-role-create"
//                     isSearchable={true}
//                     isClearable={true}
//                     isLoading={isLoadingRoles}
//                   />
//                   {!isLoadingRoles && clientRoles.length === 0 && (
//                     <span className="text-sm text-danger mt-2 d-block">
//                       No roles available
//                     </span>
//                   )}
//                 </div>
//               </div>
//               <div className="col-12">
//                 {isLoadingPermissions ? (
//                   <LoadingComponent />
//                 ) : selectedRoleId && filteredModules.length === 0 ? (
//                   <div className="d-flex justify-content-center">
//                     <span className="text-sm text-danger text-center">
//                       No permissions available. Please check configuration.
//                     </span>
//                   </div>
//                 ) : selectedRoleId ? (
//                   <div className="d-flex flex-column gap-3">
//                     <div className="d-flex align-items-center justify-content-between">
//                       <label className="form-label fw-semibold text-primary-light text-sm mb-4 d-block">
//                         Features and Permissions
//                       </label>
//                       <div className="d-flex gap-3">
//                         <button
//                           type="button"
//                           className="text-sm text-blue-600 hover:text-blue-800 transition-all"
//                           onClick={handleSelectAllModules}
//                           disabled={!selectedRoleId}
//                         >
//                           Select All Permissions
//                         </button>
//                         <button
//                           type="button"
//                           className="text-sm text-red-600 hover:text-red-800 transition-all"
//                           onClick={handleDeselectAllModules}
//                           disabled={!selectedRoleId}
//                         >
//                           Deselect All Permissions
//                         </button>
//                       </div>
//                     </div>
//                     {filteredModules.map((module, index) => (
//                       <div
//                         key={index}
//                         className="rounded-lg border border-gray-200  py-3 px-3 mb-4"
//                       >
//                         <div className="d-flex align-items-center justify-content-between mb-4">
//                           <h5 className="text-lg font-bold text-gray-900 tracking-tight">
//                             {module.name}
//                           </h5>
//                           <div className="form-check style-check d-flex align-items-center">
//                             <input
//                               className="form-check-input h-5 w-5 rounded-md border-gray-300 text-blue-600 focus:ring-blue-500 cursor-pointer"
//                               type="checkbox"
//                               checked={
//                                 !!selectedPermissions[module.name]?.__main
//                               }
//                               onChange={() =>
//                                 handleSelectAllPermissions(module.name)
//                               }
//                             />
//                           </div>
//                         </div>
//                         {module.permissions.length > 0 && (
//                           <div className="ps-4">
//                             <div className="d-flex justify-content-between align-items-center mb-3">
//                               {/* <span className="text-sm font-medium text-gray-600">
//                                 {module.name} Permissions
//                               </span> */}
//                               <button
//                                 type="button"
//                                 className="text-sm font-semibold text-blue-600 hover:text-blue-800 transition-colors duration-200"
//                                 onClick={() =>
//                                   handleSelectAllPermissions(module.name)
//                                 }
//                               >
//                                 {/* {module.permissions.every(
//                                   (perm) =>
//                                     selectedPermissions[module.name]?.[
//                                       perm.permission_key
//                                     ]
//                                 )
//                                   ? "Deselect All"
//                                   : "Select All"} */}
//                               </button>
//                             </div>
//                             <div className="d-flex gap-4 flex-wrap">
//                               {module.permissions.map((perm) => (
//                                 <div
//                                   key={perm.permission_key}
//                                   className="d-flex align-items-center gap-3 py-2"
//                                 >
//                                   <div className="form-check style-check d-flex align-items-center">
//                                     <input
//                                       className="form-check-input h-4 w-4 rounded-md border-gray-300 text-blue-600 focus:ring-blue-500 cursor-pointer"
//                                       type="checkbox"
//                                       checked={
//                                         !!selectedPermissions[module.name]?.[
//                                           perm.permission_key
//                                         ]
//                                       }
//                                       onChange={() =>
//                                         handleCheckboxChange(
//                                           module.name,
//                                           perm.permission_key
//                                         )
//                                       }
//                                     />
//                                   </div>
//                                   <span className="text-sm font-medium text-gray-700">
//                                     {perm.permission_key
//                                       .split("_")
//                                       .map(
//                                         (word) =>
//                                           word.charAt(0).toUpperCase() +
//                                           word.slice(1)
//                                       )
//                                       .join(" ")}
//                                   </span>
//                                 </div>
//                               ))}
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                     ))}
//                   </div>
//                 ) : (
//                   <div className="d-flex justify-content-center">
//                     <span className="text-sm ">
//                       Please select a role to view assigned permissions
//                     </span>
//                   </div>
//                 )}
//               </div>
//               <div className="mt-5 d-flex justify-content-center gap-3">
//                 <CancelButtonForm />
//                 <UpdateButtonForm
//                   disabled={
//                     isSubmitting ||
//                     isLoadingRoles ||
//                     isLoadingPermissions ||
//                     isLoadingRolePermissions
//                   }
//                 />
//               </div>
//             </div>
//           </form>
//         </div>
//       </div>
//     </>
//   );
// };

// export default AddNewPermissionPage;














// // src/pages/AddNewPermissionPage.jsx
// import React, { useState, useEffect, useMemo } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { apiCall } from "../Apis/apiCall";
// import Breadcrumb from "../components/Breadcrumb";
// import CustomSelect from "../components/common/CustomSelect";
// import LoadingComponent from "../components/ui/LoadingComponent";
// import { CancelButtonForm, UpdateButtonForm } from "../components/ui/Button";
// import { handleApiResponse, handleCustomResponse } from "../utils/response";
// import { Icon } from "@iconify/react/dist/iconify.js"; // 👈 NEW: Import Icon
// import InfoModal from "../components/ui/InfoeModal"; // 👈 NEW: Import InfoModal

// const AddNewPermissionPage = () => {
//   const [selectedPermissions, setSelectedPermissions] = useState({});
//   const [selectedRoleId, setSelectedRoleId] = useState("");
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [clientRoles, setClientRoles] = useState([]);
//   const [isLoadingRoles, setIsLoadingRoles] = useState(false);
//   const [allPermissions, setAllPermissions] = useState([]);
//   const [isLoadingPermissions, setIsLoadingPermissions] = useState(false);
//   const [rolePermissions, setRolePermissions] = useState([]);
//   const [isLoadingRolePermissions, setIsLoadingRolePermissions] =
//     useState(false);
//   const navigate = useNavigate();
//   const [modules, setModules] = useState([]);
//   const [showInfoModal, setShowInfoModal] = useState(false); // 👈 NEW: Info Modal State

//   // 👈 NEW: Info Modal Handlers
//   const handleInfoClick = () => {
//     setShowInfoModal(true);
//   };

//   const handleInfoClose = () => {
//     setShowInfoModal(false);
//   };

//   // Fetch client roles
//   useEffect(() => {
//     const fetchClientRoles = async () => {
//       setIsLoadingRoles(true);
//       try {
//         const response = await apiCall(
//           "get",
//           "/get-all-client-roles?want_pagination=0&sort_by=role_name&sort_order=asc"
//         );
//         if (!response?.data?.data) {
//           throw new Error("Invalid response format from server.");
//         }
//         const roles = Array.isArray(response.data.data)
//           ? response.data.data
//           : [];
//         const uniqueRoles = roles.map((role) => ({
//           id: role.client_role_id,
//           name: role.role_name || `Role ${role.client_role_id}`,
//         }));
//         setClientRoles(uniqueRoles);
//       } catch (error) {
//         setClientRoles([]);
//       } finally {
//         setIsLoadingRoles(false);
//       }
//     };
//     fetchClientRoles();
//   }, []);

//   // Fetch all permissions and role permissions on role selection
//   useEffect(() => {
//     if (!selectedRoleId) {
//       setAllPermissions([]);
//       setRolePermissions([]);
//       setSelectedPermissions({});
//       setModules([]);
//       return;
//     }
//     const fetchData = async () => {
//       setIsLoadingPermissions(true);
//       setIsLoadingRolePermissions(true);
//       try {
//         const permResponse = await apiCall(
//           "get",
//           "/get-all-client-permissions?want_pagination=0&sort_by=module_name&sort_order=asc"
//         );
//         if (!permResponse?.data?.data) {
//           throw new Error("Invalid response format from server.");
//         }
//         const permissions = Array.isArray(permResponse.data.data)
//           ? permResponse.data.data
//           : [];
//         setAllPermissions(permissions);
//         const moduleMap = {};
//         permissions.forEach((perm) => {
//           const moduleName = perm.module_name || "General";
//           if (!moduleMap[moduleName]) {
//             moduleMap[moduleName] = { name: moduleName, permissions: [] };
//           }
//           moduleMap[moduleName].permissions.push({
//             permission_key: perm.permission_key,
//             client_permission_id: perm.client_permission_id,
//           });
//         });
//         setModules(Object.values(moduleMap));
//         const rolePermResponse = await apiCall(
//           "get",
//           `/get-client-role-permissions-by-id?client_role_id=${selectedRoleId}`
//         );
//         if (!rolePermResponse?.data?.data) {
//           throw new Error("Invalid response format from server.");
//         }
//         const rolePerms = Array.isArray(rolePermResponse.data.data)
//           ? rolePermResponse.data.data
//           : [];
//         setRolePermissions(rolePerms);
//       } catch (error) {
//         setAllPermissions([]);
//         setRolePermissions([]);
//         setModules([]);
//       } finally {
//         setIsLoadingPermissions(false);
//         setIsLoadingRolePermissions(false);
//       }
//     };
//     fetchData();
//   }, [selectedRoleId]);

//   // Update selected permissions based on role permissions
//   useEffect(() => {
//     if (!rolePermissions.length && !allPermissions.length) {
//       setSelectedPermissions({});
//       return;
//     }
//     const newSelectedPermissions = {};
//     modules.forEach((module) => {
//       newSelectedPermissions[module.name] = {};
//       module.permissions.forEach((perm) => {
//         const rolePerm = rolePermissions.find(
//           (rp) =>
//             rp.client_permission_id === perm.client_permission_id &&
//             rp.is_allowed &&
//             allPermissions.some(
//               (p) => p.client_permission_id === rp.client_permission_id
//             )
//         );
//         newSelectedPermissions[module.name][perm.permission_key] = !!rolePerm;
//       });
//       newSelectedPermissions[module.name].__main = module.permissions.every(
//         (perm) => newSelectedPermissions[module.name][perm.permission_key]
//       );
//     });
//     setSelectedPermissions(newSelectedPermissions);
//   }, [rolePermissions, modules, allPermissions]);

//   // Handle checkbox change
//   const handleCheckboxChange = (moduleName, permissionKey) => {
//     setSelectedPermissions((prev) => {
//       const newSelected = { ...prev };
//       newSelected[moduleName] = newSelected[moduleName] || {};
//       newSelected[moduleName][permissionKey] =
//         !newSelected[moduleName][permissionKey];
//       const module = modules.find((m) => m.name === moduleName);
//       if (module) {
//         newSelected[moduleName].__main = module.permissions.every(
//           (perm) => newSelected[moduleName][perm.permission_key]
//         );
//       }
//       return newSelected;
//     });
//   };

//   // Select/deselect all permissions for a module
//   const handleSelectAllPermissions = (moduleName) => {
//     setSelectedPermissions((prev) => {
//       const newSelected = { ...prev };
//       newSelected[moduleName] = newSelected[moduleName] || {};
//       const module = modules.find((m) => m.name === moduleName);
//       const allSelected = module.permissions.every(
//         (perm) => newSelected[moduleName][perm.permission_key]
//       );
//       module.permissions.forEach((perm) => {
//         newSelected[moduleName][perm.permission_key] = !allSelected;
//       });
//       newSelected[moduleName].__main = !allSelected;
//       return newSelected;
//     });
//   };

//   // Select all modules
//   const handleSelectAllModules = () => {
//     setSelectedPermissions((prev) => {
//       const newSelected = { ...prev };
//       modules.forEach((module) => {
//         newSelected[module.name] = newSelected[module.name] || {};
//         module.permissions.forEach((perm) => {
//           newSelected[module.name][perm.permission_key] = true;
//         });
//         newSelected[module.name].__main = true;
//       });
//       return newSelected;
//     });
//   };

//   // Deselect all modules
//   const handleDeselectAllModules = () => {
//     setSelectedPermissions((prev) => {
//       const newSelected = { ...prev };
//       modules.forEach((module) => {
//         newSelected[module.name] = newSelected[module.name] || {};
//         module.permissions.forEach((perm) => {
//           newSelected[module.name][perm.permission_key] = false;
//         });
//         newSelected[module.name].__main = false;
//       });
//       return newSelected;
//     });
//   };

//   // Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!selectedRoleId) {
//       handleCustomResponse("error", "Please select a valid role.");
//       return;
//     }
//     setIsSubmitting(true);
//     const selectedPermissionIds = [];
//     Object.keys(selectedPermissions).forEach((moduleName) => {
//       const module = modules.find((m) => m.name === moduleName);
//       if (module) {
//         Object.keys(selectedPermissions[moduleName]).forEach(
//           (permissionKey) => {
//             if (
//               permissionKey !== "__main" &&
//               selectedPermissions[moduleName][permissionKey]
//             ) {
//               const permission = module.permissions.find(
//                 (perm) => perm.permission_key === permissionKey
//               );
//               if (permission && permission.client_permission_id) {
//                 selectedPermissionIds.push(permission.client_permission_id);
//               }
//             }
//           }
//         );
//       }
//     });
//     const uniquePermissionIds = [...new Set(selectedPermissionIds)];
//     try {
//       const assignPayload = {
//         client_role_id: parseInt(selectedRoleId),
//         client_permission_ids: uniquePermissionIds,
//       };
//       const response = await apiCall(
//         "post",
//         "/assign-role-permissions",
//         assignPayload
//       );
//       handleApiResponse(
//         response.data,
//         "Permissions assigned successfully!",
//         "POST"
//       );

//       setSelectedRoleId("");
//       setSelectedPermissions({});
//       navigate(-1);
//     } catch (error) {
//       const err = error.response?.data || error.message;
//       handleApiResponse(err, "Failed to update permissions.", "POST");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   // Optimize filtered modules with useMemo
//   const filteredModules = useMemo(
//     () => (allPermissions.length > 0 ? modules : []),
//     [allPermissions, modules]
//   );

//   return (
//     <>
//       <Breadcrumb title={"Assign Permission"} />
//       <div className="card h-100 p-0 radius-12">
//         <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center justify-content-between">
//           <h6 className="mb-0 text-primary-light">Permission Assignment</h6>
//           {/* 👈 NEW: Info Button */}
//           <button
//             type="button"
//             className="bg-info-50 text-info-600 bg-hover-info-100 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
//             data-bs-toggle="tooltip"
//             data-bs-placement="top"
//             title="Information about Permission Assignment"
//             onClick={handleInfoClick}
//             aria-label="Page Information"
//           >
//             <Icon icon="lucide:info" className="menu-icon" />
//           </button>
//         </div>
//         <div className="card-body p-40">
//           <form onSubmit={handleSubmit}>
//             <div className="row gy-4">
//               <div className="col-12">
//                 <div className="mb-6">
//                   <label className="form-label fw-semibold text-primary-light text-sm mb-2">
//                     Select Role <span className="text-danger">*</span>
//                   </label>

//                   <CustomSelect
//                     name="role"
//                     value={selectedRoleId}
//                     onChange={(selected) =>
//                       setSelectedRoleId(selected ? selected.value : "")
//                     }
//                     options={clientRoles.map((role) => ({
//                       label: role.name
//                         .split("_")
//                         .map(
//                           (word) => word.charAt(0).toUpperCase() + word.slice(1)
//                         )
//                         .join(" "),
//                       value: role.id,
//                     }))}
//                     placeholder="Select a role"
//                     addNewLabel="Add New Role"
//                     addNewRoute="/staff-role-create"
//                     isSearchable={true}
//                     isClearable={true}
//                     isLoading={isLoadingRoles}
//                   />
//                   {!isLoadingRoles && clientRoles.length === 0 && (
//                     <span className="text-sm text-danger mt-2 d-block">
//                       No roles available
//                     </span>
//                   )}
//                 </div>
//               </div>
//               <div className="col-12">
//                 {isLoadingPermissions ? (
//                   <LoadingComponent />
//                 ) : selectedRoleId && filteredModules.length === 0 ? (
//                   <div className="d-flex justify-content-center">
//                     <span className="text-sm text-danger text-center">
//                       No permissions available. Please check configuration.
//                     </span>
//                   </div>
//                 ) : selectedRoleId ? (
//                   <div className="d-flex flex-column gap-3">
//                     <div className="d-flex align-items-center justify-content-between">
//                       <label className="form-label fw-semibold text-primary-light text-sm mb-4 d-block">
//                         Features and Permissions
//                       </label>
//                       <div className="d-flex gap-3">
//                         <button
//                           type="button"
//                           className="text-sm text-blue-600 hover:text-blue-800 transition-all"
//                           onClick={handleSelectAllModules}
//                           disabled={!selectedRoleId}
//                         >
//                           Select All Permissions
//                         </button>
//                         <button
//                           type="button"
//                           className="text-sm text-red-600 hover:text-red-800 transition-all"
//                           onClick={handleDeselectAllModules}
//                           disabled={!selectedRoleId}
//                         >
//                           Deselect All Permissions
//                         </button>
//                       </div>
//                     </div>
//                     {filteredModules.map((module, index) => (
//                       <div
//                         key={index}
//                         className="rounded-lg border border-gray-200  py-3 px-3 mb-4"
//                       >
//                         <div className="d-flex align-items-center justify-content-between mb-4">
//                           <h5 className="text-lg font-bold text-gray-900 tracking-tight">
//                             {module.name}
//                           </h5>
//                           <div className="form-check style-check d-flex align-items-center">
//                             <input
//                               className="form-check-input h-5 w-5 rounded-md border-gray-300 text-blue-600 focus:ring-blue-500 cursor-pointer"
//                               type="checkbox"
//                               checked={
//                                 !!selectedPermissions[module.name]?.__main
//                               }
//                               onChange={() =>
//                                 handleSelectAllPermissions(module.name)
//                               }
//                             />
//                           </div>
//                         </div>
//                         {module.permissions.length > 0 && (
//                           <div className="ps-4">
//                             <div className="d-flex justify-content-between align-items-center mb-3">
//                               <button
//                                 type="button"
//                                 className="text-sm font-semibold text-blue-600 hover:text-blue-800 transition-colors duration-200"
//                                 onClick={() =>
//                                   handleSelectAllPermissions(module.name)
//                                 }
//                               >
//                                 {/* {module.permissions.every(
//                                   (perm) =>
//                                     selectedPermissions[module.name]?.[
//                                       perm.permission_key
//                                     ]
//                                 )
//                                   ? "Deselect All"
//                                   : "Select All"} */}
//                               </button>
//                             </div>
//                             <div className="d-flex gap-4 flex-wrap">
//                               {module.permissions.map((perm) => (
//                                 <div
//                                   key={perm.permission_key}
//                                   className="d-flex align-items-center gap-3 py-2"
//                                 >
//                                   <div className="form-check style-check d-flex align-items-center">
//                                     <input
//                                       className="form-check-input h-4 w-4 rounded-md border-gray-300 text-blue-600 focus:ring-blue-500 cursor-pointer"
//                                       type="checkbox"
//                                       checked={
//                                         !!selectedPermissions[module.name]?.[
//                                           perm.permission_key
//                                         ]
//                                       }
//                                       onChange={() =>
//                                         handleCheckboxChange(
//                                           module.name,
//                                           perm.permission_key
//                                         )
//                                       }
//                                     />
//                                   </div>
//                                   <span className="text-sm font-medium text-gray-700">
//                                     {perm.permission_key
//                                       .split("_")
//                                       .map(
//                                         (word) =>
//                                           word.charAt(0).toUpperCase() +
//                                           word.slice(1)
//                                       )
//                                       .join(" ")}
//                                   </span>
//                                 </div>
//                               ))}
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                     ))}
//                   </div>
//                 ) : (
//                   <div className="d-flex justify-content-center">
//                     <span className="text-sm ">
//                       Please select a role to view assigned permissions
//                     </span>
//                   </div>
//                 )}
//               </div>
//               <div className="mt-5 d-flex justify-content-center gap-3">
//                 <CancelButtonForm />
//                 <UpdateButtonForm
//                   disabled={
//                     isSubmitting ||
//                     isLoadingRoles ||
//                     isLoadingPermissions ||
//                     isLoadingRolePermissions
//                   }
//                 />
//               </div>
//             </div>
//           </form>
//         </div>
//       </div>

//       {/* 👈 NEW: Info Modal - EXACTLY SAME STYLE AS Other Pages */}
//       <InfoModal
//         isOpen={showInfoModal}
//         onClose={handleInfoClose}
//         title="Permission Assignment - Complete Guide"
//       >
//         <p className="text-neutral-900 mb-4">
//           This page is your <strong>central control panel</strong> for managing what different user roles can access and do in the system. 
//           Think of it as setting up <strong>digital access levels</strong> for your team members based on their job responsibilities.
//         </p>

//         <h6 className="fw-bold text-primary-600 mb-3">How It Works - Step by Step</h6>
//         <ul className="list-group list-group-flush mb-4">
//           <li className="list-group-item">
//             <strong>Step 1: Select Role</strong><br/>
//             • Choose which role you want to assign permissions to<br/>
//             • Roles = Job positions (Manager, Staff, Admin, etc.)<br/>
//             • Each role gets different access levels
//           </li>
//           <li className="list-group-item">
//             <strong>Step 2: Review Modules</strong><br/>
//             • System automatically shows available modules<br/>
//             • Each module = A section of the application<br/>
//             • Examples: Dashboard, Staff Management, Workflows, etc.
//           </li>
//           <li className="list-group-item">
//             <strong>Step 3: Assign Permissions</strong><br/>
//             • Check boxes for what this role should access<br/>
//             • Uncheck for restricted areas<br/>
//             • Use "Select All" for quick assignment
//           </li>
//         </ul>

//         <h6 className="fw-bold text-primary-600 mb-3">Permission Types Explained</h6>
//         <ul className="list-group list-group-flush mb-4">
//           <li className="list-group-item">
//             <strong>View/Read Permissions</strong><br/>
//             • Can see data and pages<br/>
//             • Read-only access<br/>
//             • Safe for most staff members
//           </li>
//           <li className="list-group-item">
//             <strong>Create/Add Permissions</strong><br/>
//             • Can add new records<br/>
//             • Create new entries<br/>
//             • For team leads and managers
//           </li>
//           <li className="list-group-item">
//             <strong>Edit/Update Permissions</strong><br/>
//             • Can modify existing data<br/>
//             • Update information<br/>
//             • For supervisors
//           </li>
//           <li className="list-group-item">
//             <strong>Delete Permissions</strong><br/>
//             • Can remove records<br/>
//             • Highest level of access<br/>
//             • For administrators only
//           </li>
//         </ul>

//         <h6 className="fw-bold text-primary-600 mb-3">Best Practices for Assignment</h6>
//         <ul className="list-group list-group-flush mb-4">
//           <li className="list-group-item">
//             <strong>For Regular Staff</strong><br/>
//             • Basic view permissions only<br/>
//             • Access to their work areas<br/>
//             • No delete or sensitive data access
//           </li>
//           <li className="list-group-item">
//             <strong>For Team Leaders</strong><br/>
//             • View + Create + Edit permissions<br/>
//             • Manage their team's work<br/>
//             • Limited delete access if needed
//           </li>
//           <li className="list-group-item">
//             <strong>For Managers/Admins</strong><br/>
//             • Full access to all modules<br/>
//             • Can manage users and settings<br/>
//             • Complete system control
//           </li>
//         </ul>

//         <h6 className="fw-bold text-primary-600 mb-3">Quick Action Buttons</h6>
//         <ul className="list-group list-group-flush mb-4">
//           <li className="list-group-item"><strong>Select All Permissions</strong> – Give full access quickly</li>
//           <li className="list-group-item"><strong>Deselect All Permissions</strong> – Reset and start fresh</li>
//           <li className="list-group-item"><strong>Module Checkboxes</strong> – Toggle entire module access</li>
//           <li className="list-group-item"><strong>Individual Permissions</strong> – Fine-tune specific access</li>
//         </ul>

//         <div className="alert alert-info small mt-4">
//           <strong>Security Tips:</strong><br/>
//           • Follow "Principle of Least Privilege" - give only necessary access<br/>
//           • Regularly review and update permissions<br/>
//           • Create role templates for consistency<br/>
//           • Test permissions with test users before full deployment<br/>
//           • Document your permission structure for future reference
//         </div>

//         <p className="text-neutral-900 mt-4 fw-bold text-primary">
//           Remember: Proper permissions = Better security + Efficient workflow + Clear responsibilities!
//         </p>
//         <p className="text-neutral-900 small">
//           Business Impact: Well-defined roles prevent data breaches, ensure compliance, streamline operations, and make team management much easier.
//         </p>
//       </InfoModal>
//     </>
//   );
// };

// export default AddNewPermissionPage;



// src/pages/AddNewPermissionPage.jsx
import React, { useState, useEffect, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { apiCall } from "../Apis/apiCall";
import Breadcrumb from "../components/Breadcrumb";
import CustomSelect from "../components/common/CustomSelect";
import LoadingComponent from "../components/ui/LoadingComponent";
import { CancelButtonForm, UpdateButtonForm } from "../components/ui/Button";
import { handleApiResponse, handleCustomResponse } from "../utils/response";
import { Icon } from "@iconify/react/dist/iconify.js"; // 👈 NEW: Import Icon
import InfoModal from "../components/ui/InfoeModal"; // 👈 NEW: Import InfoModal
import { Tooltip } from "react-tooltip";

const AddNewPermissionPage = () => {
  const [selectedPermissions, setSelectedPermissions] = useState({});
  const [selectedRoleId, setSelectedRoleId] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [clientRoles, setClientRoles] = useState([]);
  const [isLoadingRoles, setIsLoadingRoles] = useState(false);
  const [allPermissions, setAllPermissions] = useState([]);
  const [isLoadingPermissions, setIsLoadingPermissions] = useState(false);
  const [rolePermissions, setRolePermissions] = useState([]);
  const [isLoadingRolePermissions, setIsLoadingRolePermissions] =
    useState(false);
  const navigate = useNavigate();
  const [modules, setModules] = useState([]);
  const [showInfoModal, setShowInfoModal] = useState(false); // 👈 NEW: Info Modal State

  // 👈 NEW: Info Modal Handlers
  const handleInfoClick = () => {
    setShowInfoModal(true);
  };

  const handleInfoClose = () => {
    setShowInfoModal(false);
  };

  // Fetch client roles
  useEffect(() => {
    const fetchClientRoles = async () => {
      setIsLoadingRoles(true);
      try {
        const response = await apiCall(
          "get",
          "/get-all-client-roles?want_pagination=0&sort_by=role_name&sort_order=asc"
        );
        if (!response?.data?.data) {
          throw new Error("Invalid response format from server.");
        }
        const roles = Array.isArray(response.data.data)
          ? response.data.data
          : [];
        const uniqueRoles = roles.map((role) => ({
          id: role.client_role_id,
          name: role.role_name || `Role ${role.client_role_id}`,
        }));
        setClientRoles(uniqueRoles);
      } catch (error) {
        setClientRoles([]);
      } finally {
        setIsLoadingRoles(false);
      }
    };
    fetchClientRoles();
  }, []);

  // Fetch all permissions and role permissions on role selection
  useEffect(() => {
    if (!selectedRoleId) {
      setAllPermissions([]);
      setRolePermissions([]);
      setSelectedPermissions({});
      setModules([]);
      return;
    }
    const fetchData = async () => {
      setIsLoadingPermissions(true);
      setIsLoadingRolePermissions(true);
      try {
        const permResponse = await apiCall(
          "get",
          "/get-all-client-permissions?want_pagination=0&sort_by=module_name&sort_order=asc"
        );
        if (!permResponse?.data?.data) {
          throw new Error("Invalid response format from server.");
        }
        const permissions = Array.isArray(permResponse.data.data)
          ? permResponse.data.data
          : [];
        setAllPermissions(permissions);
        // const moduleMap = {};
        // permissions.forEach((perm) => {
        //   const moduleName = perm.module_name || "General";
        //   if (!moduleMap[moduleName]) {
        //     moduleMap[moduleName] = { name: moduleName, permissions: [] };
        //   }
        //   moduleMap[moduleName].permissions.push({
        //     permission_key: perm.permission_key,
        //     client_permission_id: perm.client_permission_id,
        //   });
        // });
        // setModules(Object.values(moduleMap));
        // new code 
                // ← YE PURA BLOCK REPLACE KAR DO (moduleMap banane ke baad) →

        // const moduleMap = {};
        // permissions.forEach((perm) => {
        //   const moduleName = perm.module_name || "General";
        //   if (!moduleMap[moduleName]) {
        //     moduleMap[moduleName] = { name: moduleName, permissions: [] };
        //   }
        //   moduleMap[moduleName].permissions.push({
        //     permission_key: perm.permission_key,
        //     client_permission_id: perm.client_permission_id,
        //   });
        // });

        // // Aapka Apna Order Yaha Likho (jo bhi chahe, jaisa chahe)
        // const MY_CUSTOM_ORDER = [
        //   "Main Pages",               // 1st
        //   "Staff Management",
        //   "Staff Roles",
        //   "Staff Branches",
        //   "Branches",
        //   "Locations",
        //   "Customer Profile",
        //   "Vehicle Pricing",
        //   "Slot Overview",
        //   "Incentive Plan",
        //   "Incentive Assignment",
        //   "Report",
        //   "Mobile App",
        //   "Permission",
        //   "Subscription",
        //   "Usage Statistics",
        //   "Workflow"                  // Last me
        //   // agar koi naya module aaye, upar add kar dena
        // ];

        // // Auto sorting apne order ke hisaab se
        // const sortedModules = Object.values(moduleMap).sort((a, b) => {
        //   const aIndex = MY_CUSTOM_ORDER.indexOf(a.name);
        //   const bIndex = MY_CUSTOM_ORDER.indexOf(b.name);

        //   // Jo order list me nahi hai, unko last me bhej do
        //   if (aIndex === -1) return 1;
        //   if (bIndex === -1) return -1;

        //   return aIndex - bIndex;
        // });

        // setModules(sortedModules);
        const moduleMap = {};
permissions.forEach((perm) => {
  const moduleName = perm.module_name || "General";
  if (!moduleMap[moduleName]) {
    moduleMap[moduleName] = { name: moduleName, permissions: [] };
  }
  moduleMap[moduleName].permissions.push({
    permission_key: perm.permission_key,
    client_permission_id: perm.client_permission_id,
    description: perm.description, // ← optional: agar baad me use karna ho
    sort_order: perm.sort_order, // ← optional: agar baad me use karna ho
  });
});

// NAYA ADDITION: Har module ke andar permissions ko sort_order ke hisaab se sort kar do
Object.values(moduleMap).forEach((module) => {
  module.permissions.sort((a, b) => a.sort_order - b.sort_order);
});

// Baaki ka code same rahega (custom module order wala)
const MY_CUSTOM_ORDER = [
  "Main Pages",
  "Staff Management",
  "Staff Roles",
  "Staff Branches",
  "Branches",
  "Locations",
  "Customer Profile",
  "Vehicle Pricing",
  "Slot Overview",
  "Incentive Plan",
  "Incentive Assignment",
  "Report",
  "Mobile App",
  "Permission",
  "Subscription",
  "Usage Statistics",
  "Workflow"
];

const sortedModules = Object.values(moduleMap).sort((a, b) => {
  const aIndex = MY_CUSTOM_ORDER.indexOf(a.name);
  const bIndex = MY_CUSTOM_ORDER.indexOf(b.name);
  if (aIndex === -1) return 1;
  if (bIndex === -1) return -1;
  return aIndex - bIndex;
});

setModules(sortedModules);
        // ← TAK YE CODE LAGA DO →
        const rolePermResponse = await apiCall(
          "get",
          `/get-client-role-permissions-by-id?client_role_id=${selectedRoleId}`
        );
        if (!rolePermResponse?.data?.data) {
          throw new Error("Invalid response format from server.");
        }
        const rolePerms = Array.isArray(rolePermResponse.data.data)
          ? rolePermResponse.data.data
          : [];
        setRolePermissions(rolePerms);
      } catch (error) {
        setAllPermissions([]);
        setRolePermissions([]);
        setModules([]);
      } finally {
        setIsLoadingPermissions(false);
        setIsLoadingRolePermissions(false);
      }
    };
    fetchData();
  }, [selectedRoleId]);

  // Update selected permissions based on role permissions
  useEffect(() => {
    if (!rolePermissions.length && !allPermissions.length) {
      setSelectedPermissions({});
      return;
    }
    const newSelectedPermissions = {};
    modules.forEach((module) => {
      newSelectedPermissions[module.name] = {};
      module.permissions.forEach((perm) => {
        const rolePerm = rolePermissions.find(
          (rp) =>
            rp.client_permission_id === perm.client_permission_id &&
            rp.is_allowed &&
            allPermissions.some(
              (p) => p.client_permission_id === rp.client_permission_id
            )
        );
        newSelectedPermissions[module.name][perm.permission_key] = !!rolePerm;
      });
      newSelectedPermissions[module.name].__main = module.permissions.every(
        (perm) => newSelectedPermissions[module.name][perm.permission_key]
      );
    });
    setSelectedPermissions(newSelectedPermissions);
  }, [rolePermissions, modules, allPermissions]);

  // Handle checkbox change
  const handleCheckboxChange = (moduleName, permissionKey) => {
    setSelectedPermissions((prev) => {
      const newSelected = { ...prev };
      newSelected[moduleName] = newSelected[moduleName] || {};
      newSelected[moduleName][permissionKey] =
        !newSelected[moduleName][permissionKey];
      const module = modules.find((m) => m.name === moduleName);
      if (module) {
        newSelected[moduleName].__main = module.permissions.every(
          (perm) => newSelected[moduleName][perm.permission_key]
        );
      }
      return newSelected;
    });
  };

  // Select/deselect all permissions for a module
  const handleSelectAllPermissions = (moduleName) => {
    setSelectedPermissions((prev) => {
      const newSelected = { ...prev };
      newSelected[moduleName] = newSelected[moduleName] || {};
      const module = modules.find((m) => m.name === moduleName);
      const allSelected = module.permissions.every(
        (perm) => newSelected[moduleName][perm.permission_key]
      );
      module.permissions.forEach((perm) => {
        newSelected[moduleName][perm.permission_key] = !allSelected;
      });
      newSelected[moduleName].__main = !allSelected;
      return newSelected;
    });
  };

  // Select all modules
  const handleSelectAllModules = () => {
    setSelectedPermissions((prev) => {
      const newSelected = { ...prev };
      modules.forEach((module) => {
        newSelected[module.name] = newSelected[module.name] || {};
        module.permissions.forEach((perm) => {
          newSelected[module.name][perm.permission_key] = true;
        });
        newSelected[module.name].__main = true;
      });
      return newSelected;
    });
  };

  // Deselect all modules
  const handleDeselectAllModules = () => {
    setSelectedPermissions((prev) => {
      const newSelected = { ...prev };
      modules.forEach((module) => {
        newSelected[module.name] = newSelected[module.name] || {};
        module.permissions.forEach((perm) => {
          newSelected[module.name][perm.permission_key] = false;
        });
        newSelected[module.name].__main = false;
      });
      return newSelected;
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedRoleId) {
      handleCustomResponse("error", "Please select a valid role.");
      return;
    }
    setIsSubmitting(true);
    const selectedPermissionIds = [];
    Object.keys(selectedPermissions).forEach((moduleName) => {
      const module = modules.find((m) => m.name === moduleName);
      if (module) {
        Object.keys(selectedPermissions[moduleName]).forEach(
          (permissionKey) => {
            if (
              permissionKey !== "__main" &&
              selectedPermissions[moduleName][permissionKey]
            ) {
              const permission = module.permissions.find(
                (perm) => perm.permission_key === permissionKey
              );
              if (permission && permission.client_permission_id) {
                selectedPermissionIds.push(permission.client_permission_id);
              }
            }
          }
        );
      }
    });
    const uniquePermissionIds = [...new Set(selectedPermissionIds)];
    try {
      const assignPayload = {
        client_role_id: parseInt(selectedRoleId),
        client_permission_ids: uniquePermissionIds,
      };
      const response = await apiCall(
        "post",
        "/assign-role-permissions",
        assignPayload
      );
      handleApiResponse(
        response.data,
        "Permissions assigned successfully!",
        "POST"
      );

      setSelectedRoleId("");
      setSelectedPermissions({});
      navigate(-1);
    } catch (error) {
      const err = error.response?.data || error.message;
      handleApiResponse(err, "Failed to update permissions.", "POST");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Optimize filtered modules with useMemo
  const filteredModules = useMemo(
    () => (allPermissions.length > 0 ? modules : []),
    [allPermissions, modules]
  );

  return (
    <>
      <Breadcrumb title={"Assign Permission"} />
      <div className="card h-100 p-0 radius-12">
        <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center justify-content-between">
          <h6 className="mb-0 text-primary-light">Permission Assignment</h6>
          {/* 👈 NEW: Info Button */}
          <button
            type="button"
            className="bg-info-50 text-info-600 bg-hover-info-100 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Information about Permission Assignment"
            onClick={handleInfoClick}
            aria-label="Page Information"
          >
            <Icon icon="lucide:info" className="menu-icon" />
          </button>
        </div>
        <div className="card-body p-40">
          <form onSubmit={handleSubmit}>
            <div className="row gy-4">
              <div className="col-12">
                <div className="mb-6">
                  <label className="form-label fw-semibold text-primary-light text-sm mb-2">
                    Select Role <span className="text-danger">*</span>
                  </label>

                  <CustomSelect
                    name="role"
                    value={selectedRoleId}
                    onChange={(selected) =>
                      setSelectedRoleId(selected ? selected.value : "")
                    }
                    options={clientRoles.map((role) => ({
                      label: role.name
                        .split("_")
                        .map(
                          (word) => word.charAt(0).toUpperCase() + word.slice(1)
                        )
                        .join(" "),
                      value: role.id,
                    }))}
                    placeholder="Select a role"
                    addNewLabel="Add New Role"
                    addNewRoute="/staff-role-create"
                    isSearchable={true}
                    isClearable={true}
                    isLoading={isLoadingRoles}
                  />
                  {!isLoadingRoles && clientRoles.length === 0 && (
                    <span className="text-sm text-danger mt-2 d-block">
                      No roles available
                    </span>
                  )}
                </div>
              </div>
              <div className="col-12">
                {isLoadingPermissions ? (
                  <LoadingComponent />
                ) : selectedRoleId && filteredModules.length === 0 ? (
                  <div className="d-flex justify-content-center">
                    <span className="text-sm text-danger text-center">
                      No permissions available. Please check configuration.
                    </span>
                  </div>
                ) : selectedRoleId ? (
                  <div className="d-flex flex-column gap-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <label className="form-label fw-semibold text-primary-light text-sm mb-4 d-block">
                        Features and Permissions
                      </label>
                      <div className="d-flex gap-3">
                        <button
                          type="button"
                          className="text-sm text-blue-600 hover:text-blue-800 transition-all"
                          onClick={handleSelectAllModules}
                          disabled={!selectedRoleId}
                        >
                          Select All Permissions
                        </button>
                        <button
                          type="button"
                          className="text-sm text-red-600 hover:text-red-800 transition-all"
                          onClick={handleDeselectAllModules}
                          disabled={!selectedRoleId}
                        >
                          Deselect All Permissions
                        </button>
                      </div>
                    </div>
                    {filteredModules.map((module, index) => (
                      <div
                        key={index}
                        className="rounded-lg border border-gray-200  py-3 px-3 mb-4"
                      >
                        <div className="d-flex align-items-center justify-content-between mb-4">
                          <h5 className="text-lg font-bold text-gray-900 tracking-tight">
                            {module.name}
                          </h5>
                          <div className="form-check style-check d-flex align-items-center">
                            <input
                              className="form-check-input h-5 w-5 rounded-md border-gray-300 text-blue-600 focus:ring-blue-500 cursor-pointer"
                              type="checkbox"
                              checked={
                                !!selectedPermissions[module.name]?.__main
                              }
                              onChange={() =>
                                handleSelectAllPermissions(module.name)
                              }
                            />
                          </div>
                        </div>
                        {module.permissions.length > 0 && (
                          <div className="ps-4">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <button
                                type="button"
                                className="text-sm font-semibold text-blue-600 hover:text-blue-800 transition-colors duration-200"
                                onClick={() =>
                                  handleSelectAllPermissions(module.name)
                                }
                              >
                                {/* {module.permissions.every(
                                  (perm) =>
                                    selectedPermissions[module.name]?.[
                                      perm.permission_key
                                    ]
                                )
                                  ? "Deselect All"
                                  : "Select All"} */}
                              </button>
                            </div>
                            <div className="d-flex gap-4 flex-wrap">
                              {module.permissions.map((perm) => (
                                <div
                                  key={perm.permission_key}
                                  className="d-flex align-items-center gap-3 py-2"
                                >
                                  <div className="form-check style-check d-flex align-items-center">
                                    <input
                                      className="form-check-input h-4 w-4 rounded-md border-gray-300 text-blue-600 focus:ring-blue-500 cursor-pointer"
                                      type="checkbox"
                                      checked={
                                        !!selectedPermissions[module.name]?.[
                                          perm.permission_key
                                        ]
                                      }
                                      onChange={() =>
                                        handleCheckboxChange(
                                          module.name,
                                          perm.permission_key
                                        )
                                      }
                                    />
                                  </div>
                                  {/* <span className="text-sm font-medium text-gray-700">
                                    {perm.permission_key
                                      .split("_")
                                      .map(
                                        (word) =>
                                          word.charAt(0).toUpperCase() +
                                          word.slice(1)
                                      )
                                      .join(" ")}
                                  </span> */}
                                  <span 
  className="text-sm font-medium text-gray-700  position-relative"
  data-tooltip-id="perm-tooltip"
  data-tooltip-content={perm.description || "No description provided"}
  data-tooltip-place="top"
  style={{cursor:"pointer"}}
>
  {perm.permission_key
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")}
  {/* <Icon icon="lucide:help-circle" className="ms-1 text-gray-400" width="14" /> */}
</span>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="d-flex justify-content-center">
                    <span className="text-sm ">
                      Please select a role to view assigned permissions
                    </span>
                  </div>
                )}
              </div>
              <div className="mt-5 d-flex justify-content-center gap-3">
                <CancelButtonForm />
                <UpdateButtonForm
                  disabled={
                    isSubmitting ||
                    isLoadingRoles ||
                    isLoadingPermissions ||
                    isLoadingRolePermissions
                  }
                />
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* 👈 NEW: Info Modal - EXACTLY SAME STYLE AS Other Pages */}
      <InfoModal
        isOpen={showInfoModal}
        onClose={handleInfoClose}
        title="Permission Assignment - Complete Guide"
      >
        <p className="text-neutral-900 mb-4">
          This page is your <strong>central control panel</strong> for managing what different user roles can access and do in the system. 
          Think of it as setting up <strong>digital access levels</strong> for your team members based on their job responsibilities.
        </p>

        <h6 className="fw-bold text-primary-600 mb-3">How It Works - Step by Step</h6>
        <ul className="list-group list-group-flush mb-4">
          <li className="list-group-item">
            <strong>Step 1: Select Role</strong><br/>
            • Choose which role you want to assign permissions to<br/>
            • Roles = Job positions (Manager, Staff, Admin, etc.)<br/>
            • Each role gets different access levels
          </li>
          <li className="list-group-item">
            <strong>Step 2: Review Modules</strong><br/>
            • System automatically shows available modules<br/>
            • Each module = A section of the application<br/>
            • Examples: Dashboard, Staff Management, Workflows, etc.
          </li>
          <li className="list-group-item">
            <strong>Step 3: Assign Permissions</strong><br/>
            • Check boxes for what this role should access<br/>
            • Uncheck for restricted areas<br/>
            • Use "Select All" for quick assignment
          </li>
        </ul>

        <h6 className="fw-bold text-primary-600 mb-3">Permission Types Explained</h6>
        <ul className="list-group list-group-flush mb-4">
          <li className="list-group-item">
            <strong>View/Read Permissions</strong><br/>
            • Can see data and pages<br/>
            • Read-only access<br/>
            • Safe for most staff members
          </li>
          <li className="list-group-item">
            <strong>Create/Add Permissions</strong><br/>
            • Can add new records<br/>
            • Create new entries<br/>
            • For team leads and managers
          </li>
          <li className="list-group-item">
            <strong>Edit/Update Permissions</strong><br/>
            • Can modify existing data<br/>
            • Update information<br/>
            • For supervisors
          </li>
          <li className="list-group-item">
            <strong>Delete Permissions</strong><br/>
            • Can remove records<br/>
            • Highest level of access<br/>
            • For administrators only
          </li>
        </ul>

        <h6 className="fw-bold text-primary-600 mb-3">Best Practices for Assignment</h6>
        <ul className="list-group list-group-flush mb-4">
          <li className="list-group-item">
            <strong>For Regular Staff</strong><br/>
            • Basic view permissions only<br/>
            • Access to their work areas<br/>
            • No delete or sensitive data access
          </li>
          <li className="list-group-item">
            <strong>For Team Leaders</strong><br/>
            • View + Create + Edit permissions<br/>
            • Manage their team's work<br/>
            • Limited delete access if needed
          </li>
          <li className="list-group-item">
            <strong>For Managers/Admins</strong><br/>
            • Full access to all modules<br/>
            • Can manage users and settings<br/>
            • Complete system control
          </li>
        </ul>

        <h6 className="fw-bold text-primary-600 mb-3">Quick Action Buttons</h6>
        <ul className="list-group list-group-flush mb-4">
          <li className="list-group-item"><strong>Select All Permissions</strong> – Give full access quickly</li>
          <li className="list-group-item"><strong>Deselect All Permissions</strong> – Reset and start fresh</li>
          <li className="list-group-item"><strong>Module Checkboxes</strong> – Toggle entire module access</li>
          <li className="list-group-item"><strong>Individual Permissions</strong> – Fine-tune specific access</li>
        </ul>

        <div className="alert alert-info small mt-4">
          <strong>Security Tips:</strong><br/>
          • Follow "Principle of Least Privilege" - give only necessary access<br/>
          • Regularly review and update permissions<br/>
          • Create role templates for consistency<br/>
          • Test permissions with test users before full deployment<br/>
          • Document your permission structure for future reference
        </div>

        <p className="text-neutral-900 mt-4 fw-bold text-primary">
          Remember: Proper permissions = Better security + Efficient workflow + Clear responsibilities!
        </p>
        <p className="text-neutral-900 small">
          Business Impact: Well-defined roles prevent data breaches, ensure compliance, streamline operations, and make team management much easier.
        </p>
      </InfoModal>
      <Tooltip id="perm-tooltip" className="z-50" />
    </>
  );
};

export default AddNewPermissionPage;